import i18n from '@/i18n/i18n.js'

const { t } = i18n.global

export const APPLICATION_STATUSES_MAP = {
  2: t('constants.constants.application_statuses_map.approved'),
  3: t('constants.constants.application_statuses_map.rejected'),
  4: t('constants.constants.application_statuses_map.completed'),
  5: t('constants.constants.application_statuses_map.cancelled'),
  6: t('constants.constants.application_statuses_map.suspended'),
  7: t('constants.constants.application_statuses_map.expired'),
  99: t('constants.constants.application_statuses_map.draft'),
  10: t('constants.constants.application_statuses_map.findeks_validation_waiting'),
  11: t('constants.constants.application_statuses_map.findeks_validated'),
  20: t('constants.constants.application_statuses_map.findeks_pin_waiting'),
  21: t('constants.constants.application_statuses_map.findeks_pin_confirmed'),
  25: t('constants.constants.application_statuses_map.findeks_report_saved'),
  29: t('constants.constants.application_statuses_map.findeks_failed'),
  30: t('constants.constants.application_statuses_map.protocol_waiting'),
  31: t('constants.constants.application_statuses_map.protocol_undecided'),
  39: t('constants.constants.application_statuses_map.protocol_failed'),
  70: t('constants.constants.application_statuses_map.survey_waiting'),
  71: t('constants.constants.application_statuses_map.survey_saved'),
  40: t('constants.constants.application_statuses_map.ad_waiting'),
  50: t('constants.constants.application_statuses_map.score_waiting'),
  59: t('constants.constants.application_statuses_map.score_failed'),
  60: t('constants.constants.application_statuses_map.payment_waiting'),
  61: t('constants.constants.application_statuses_map.payment_process'),
  69: t('constants.constants.application_statuses_map.payment_failed'),
  80: t('constants.constants.application_statuses_map.document_required'),
  81: t('constants.constants.application_statuses_map.document_waiting'),
  90: t('constants.constants.application_statuses_map.farmer_info_waiting'),
  91: t('constants.constants.application_statuses_map.farmer_info_saved'),
  100: t('constants.constants.application_statuses_map.guarantor_waiting'),
  101: t('constants.constants.application_statuses_map.guarantor_saved'),
  102: t('constants.constants.application_statuses_map.guarantor_findeks_pin_waiting'),
  103: t('constants.constants.application_statuses_map.guarantor_findeks_pin_confirmed'),
  104: t('constants.constants.application_statuses_map.guarantor_findeks_report_saved'),
  105: t('constants.constants.application_statuses_map.guarantor_protocol_waiting'),
  106: t('constants.constants.application_statuses_map.guarantor_score_waiting'),
  107: t('constants.constants.application_statuses_map.guarantor_document_required'),
  108: t('constants.constants.application_statuses_map.guarantor_document_waiting'),
  200: t('constants.constants.application_statuses_map.fiba_farmer_confirmation_waiting'),
  201: t('constants.constants.application_statuses_map.fiba_farmer_confirmation_received'),
  210: t('constants.constants.application_statuses_map.fiba_decision_waiting'),
  220: t('constants.constants.application_statuses_map.fiba_pin_waiting'),
  221: t('constants.constants.application_statuses_map.fiba_pin_confirmed'),
  230: t('constants.constants.application_statuses_map.fiba_payment_plan_waiting'),
  231: t('constants.constants.application_statuses_map.fiba_payment_plan_received'),
  235: t('constants.constants.application_statuses_map.fiba_used_process_waiting'),
  240: t('constants.constants.application_statuses_map.fiba_documents_waiting'),
  250: t('constants.constants.application_statuses_map.fiba_documents_confirmation_waiting'),
  299: t('constants.constants.application_statuses_map.fiba_process_failed'),
  900: t('constants.constants.application_statuses_map.fv_waiting'),
  901: t('constants.constants.application_statuses_map.fv_document_waiting'),
  902: t('constants.constants.application_statuses_map.fv_retailer_approval_waiting'),
  903: t('constants.constants.application_statuses_map.fv_cks_approval_waiting'),
  110: t('constants.constants.application_statuses_map.fraud_dark_detected'),
  120: t('constants.constants.application_statuses_map.fraud_detected'),
  130: t('constants.constants.application_statuses_map.ro_farmer_info_waiting'),
  140: t('constants.constants.application_statuses_map.ro_credit_report_waiting'),
  149: t('constants.constants.application_statuses_map.ro_credit_report_failed'),
  700: t('constants.constants.application_statuses_map.counter_offer_pending'),
  709: t('constants.constants.application_statuses_map.counter_offer_expired')
}
export const APPLICATION_STATUSES = {
  APPROVED: 2,
  REJECTED: 3,
  COMPLETED: 4,
  CANCELLED: 5,
  SUSPENDED: 6,
  EXPIRED: 7,
  DRAFT: 99,
  FINDEKS_VALIDATION_WAITING: 10,
  FINDEKS_VALIDATED: 11,
  FINDEKS_PIN_WAITING: 20,
  FINDEKS_PIN_CONFIRMED: 21,
  FINDEKS_REPORT_SAVED: 25,
  FINDEKS_FAILED: 29,
  PROTOCOL_WAITING: 30,
  PROTOCOL_UNDECIDED: 31,
  PROTOCOL_FAILED: 39,
  AD_WAITING: 40,
  COUNTER_OFFER_PENDING: 700,
  COUNTER_OFFER_EXPIRED: 709,
  SURVEY_WAITING: 70,
  SURVEY_SAVED: 71,
  SCORE_WAITING: 50,
  SCORE_FAILED: 59,
  PAYMENT_WAITING: 60,
  PAYMENT_PROCESS: 61,
  PAYMENT_FAILED: 69,
  DOCUMENT_REQUIRED: 80,
  DOCUMENT_WAITING: 81,
  FARMER_INFORMATION_WAITING: 90,
  FARMER_INFORMATION_SAVED: 91,
  GUARANTOR_WAITING: 100,
  GUARANTOR_SAVED: 101,
  GUARANTOR_FINDEKS_PIN_WAITING: 102,
  GUARANTOR_FINDEKS_PIN_CONFIRMED: 103,
  GUARANTOR_FINDEKS_REPORT_SAVED: 104,
  GUARANTOR_PROTOCOL_WAITING: 105,
  GUARANTOR_SCORE_WAITING: 106,
  GUARANTOR_DOCUMENT_REQUIRED: 107,
  GUARANTOR_DOCUMENT_WAITING: 108,
  FV_WAITING: 900,
  FV_DOCUMENT_WAITING: 901,
  FV_RETAILER_APPROVAL_WAITING: 902,
  FV_CKS_APPROVAL_WAITING: 903,
  FIBA_FARMER_CONFIRMATION_WAITING: 200,
  FIBA_FARMER_CONFIRMATION_RECEIVED: 201,
  FIBA_DECISION_WAITING: 210,
  FIBA_PIN_WAITING: 220,
  FIBA_PIN_CONFIRMED: 221,
  FIBA_PAYMENT_PLAN_WAITING: 230,
  FIBA_PAYMENT_PLAN_RECEIVED: 231,
  FIBA_USED_PROCESS_WAITING: 235,
  FIBA_DOCUMENTS_WAITING: 240,
  FIBA_DOCUMENTS_CONFIRMATION_WAITING: 250,
  FIBA_PROCESS_FAILED: 299,
  FRAUD_DARK_DETECTED: 110,
  FRAUD_DETECTED: 120,
  RO_FARMER_INFO_WAITING: 130,
  RO_CREDIT_REPORT_WAITING: 140,
  RO_CREDIT_REPORT_FAILED: 149
}
export const APPLICATION_STATUS_CLASS_MAP = {
  20: 'badge-light-lighten',
  40: 'badge-info-lighten',
  2: 'badge-success-lighten',
  3: 'badge-danger-lighten',
  4: 'badge-primary-lighten',
  5: 'badge-dark-lighten',
  6: 'badge-dark-lighten',
  29: 'badge-danger-lighten',
  39: 'badge-danger-lighten',
  69: 'badge-danger-lighten',
  200: 'badge-indigo-lighten',
  210: 'badge-info-lighten',
  220: 'badge-light-lighten',
  230: 'badge-purple-lighten',
  240: 'badge-cyan-lighten',
  250: 'badge-warning-lighten',
  299: 'badge-danger-lighten',
  900: 'badge-info-lighten',
  901: 'badge-info-lighten',
  902: 'badge-info-lighten',
  903: 'badge-info-lighten',
  110: 'badge-warning-lighten',
  120: 'badge-warning-lighten',
  130: 'badge-light-lighten',
  140: 'badge-info-lighten',
  149: 'badge-danger-lighten'
}

export const APPLICATION_FRAUD_STATUS = {
  DRAFT: 0,
  PENDING: 1,
  APPROVED: 2,
  REJECTED: 4
}

export const PAYMENT_STATUSES = {
  DRAFT: 0,
  OPEN: 1,
  PARTLY_PAID: 2,
  FULLY_PAID: 3,
  BLOCKED: 4,
  DEFAULTED: 5,
  ACCELERATED: 6
}

export const UNPAID_PAYMENT_STATUSES = [
  PAYMENT_STATUSES.OPEN,
  PAYMENT_STATUSES.PARTLY_PAID,
  PAYMENT_STATUSES.DEFAULTED,
  PAYMENT_STATUSES.ACCELERATED
]
export const PAYMENT_STATUSES_MAP = {
  0: t('constants.constants.payment_statuses_map.draft'),
  1: t('constants.constants.payment_statuses_map.waiting'),
  2: t('constants.constants.payment_statuses_map.partly_paid'),
  3: t('constants.constants.payment_statuses_map.fully_paid'),
  4: t('constants.constants.payment_statuses_map.blocked'),
  5: t('constants.constants.payment_statuses_map.accelerated'),
  6: t('constants.constants.payment_statuses_map.accelerated')
}

export const CREDIT_CARD_PAYMENT_STATUS_MAP = {
  0: t('constants.constants.payment_statuses_map.draft'),
  1: t('constants.constants.payment_statuses_map.credit_card_waiting'),
  2: t('constants.constants.payment_statuses_map.partly_collected'),
  3: t('constants.constants.payment_statuses_map.fully_collected'),
  4: t('constants.constants.payment_statuses_map.blocked')
}

export const PAYMENT_STATUSES_FOR_NETTING_MAP = {
  0: t('constants.constants.payment_statuses_map.draft'),
  1: t('constants.constants.payment_statuses_map.waiting'),
  2: t('constants.constants.payment_statuses_map.partly_collected'),
  3: t('constants.constants.payment_statuses_map.fully_collected'),
  4: t('constants.constants.payment_statuses_map.blocked')
}

export const PAYMENT_STATUSES_MAP_PRO_QUOTATION = {
  0: t('constants.constants.payment_statuses_map.draft'),
  1: t('constants.constants.payment_statuses_map.pro_waiting'),
  2: t('constants.constants.payment_statuses_map.partly_paid'),
  3: t('constants.constants.payment_statuses_map.fully_paid'),
  4: t('constants.constants.payment_statuses_map.blocked')
}

export const ORDER_MATCH_STATUSES = {
  UNTOUCHED: 100,
  AUTO_MATCHED: 200,
  MANUAL_MATCHED: 300,
  NO_MATCH: 400,
  APPROVED: 500,
  MANUAL_COLLECTION: 600,
  REFUND_WITHOUT_COLLECTION: 700
}

export const ORDER_MATCH_STATUSES_MAP = {
  200: t('views.admin.incoming_payments.auto_matched_payments'),
  300: t('views.admin.incoming_payments.matched_payments'),
  400: t('views.admin.incoming_payments.unmatched_payments'),
  500: t('views.admin.incoming_payments.approved_payments'),
  600: t('views.admin.incoming_payments.manual_collection'),
  700: t('views.admin.incoming_payments.refund_without_collection')
}

export const ORDER_STATUSES = {
  DRAFT: 0,
  COMPLETED: 1,
  PENDING_CANCELLATION: 2
}

export const ORDER_STATUSES_MAP = {
  0: t('constants.constants.order_statuses_map.draft'),
  1: t('constants.constants.order_statuses_map.completed'),
  2: t('constants.constants.order_statuses_map.pending_cancellation')
}

export const APPLICATION_DECISIONS = {
  DRAFT: 0,
  APPROVED: 1,
  AUTO_APPROVED: 2,
  CONDITIONAL_APPROVED: 3,
  REJECTED: 4, // Tahsis Ret
  CONDITIONAL_REJECTED: 5, // Koşullu Ret
  AUTO_REJECTED: 6, // ML Reject
  PROTOCOL_REJECTED: 7, // Protokol Ret
  RETAILER_FRAUD_DETECTED: 8, // Kötüye Kullanım: Bayi
  PROTOCOL_APPROVED: 9, // Politika Onay
  APPROVED_WITH_RETAILER_INITIATIVE: 10, // Bayi insiyatifi ile Onay
  GUARANTOR_APPROVED: 11, // Kefilli Onay
  GUARANTOR_REJECTED: 12, // Kefilli Ret
  FRAUD_DETECTED: 13, // Kötüye Kullanım: Çiftçi
  FRAUD_DARK_DETECTED: 14 // Şüpheli Başvuru: Bayi Onayı
}

export const APPLICATION_DECISIONS_MAP = {
  0: t('constants.constants.application_decisions_map.draft'),
  1: t('constants.constants.application_decisions_map.approved'),
  2: t('constants.constants.application_decisions_map.auto_approved'),
  3: t('constants.constants.application_decisions_map.conditional_approved'),
  4: t('constants.constants.application_decisions_map.rejected'),
  5: t('constants.constants.application_decisions_map.conditional_rejected'),
  6: t('constants.constants.application_decisions_map.auto_rejected'),
  7: t('constants.constants.application_decisions_map.protocol_rejected'),
  8: t('constants.constants.application_decisions_map.retailer_fraud_detected'),
  9: t('constants.constants.application_decisions_map.protocol_approved'),
  10: t('constants.constants.application_decisions_map.approved_with_retailer_initiative'),
  11: t('constants.constants.application_decisions_map.guarantor_approved'),
  12: t('constants.constants.application_decisions_map.guarantor_rejected'),
  13: t('constants.constants.application_decisions_map.fraud_detected'),
  14: t('constants.constants.application_decisions_map.fraud_dark_detected')
}

export const FINDEKS_REPORT_REASON_TYPES = {
  APPLICATION: 0,
  PAYMENT_45_DAYS_BEFORE: 1,
  PAYMENT_DAY: 2,
  PRE_APPROVAL: 3,
  GUARANTOR: 4,
  PRE_APPROVED_LIMIT: 5,
  EPIC_FAIL: 100
}

export const FINDEKS_REPORT_REASON_TYPES_MAP = {
  0: t('constants.constants.findeks_report_reason_types_map.application'),
  1: t('constants.constants.findeks_report_reason_types_map.payment_45_days_before'),
  2: t('constants.constants.findeks_report_reason_types_map.payment_day'),
  3: t('constants.constants.findeks_report_reason_types_map.pre_approval'),
  4: t('constants.constants.findeks_report_reason_types_map.guarantor'),
  5: t('constants.constants.findeks_report_reason_types_map.pre_approved_limit'),
  100: t('constants.constants.findeks_report_reason_types_map.epic_fail')
}

export const QUESTION_TYPES = {
  INPUT: 0,
  CHECKBOX: 1,
  RADIO: 2,
  SINGLE_SELECT: 3,
  MULTIPLE_SELECT: 4,
  DATEPICKER: 5,
  RATED: 6
}

export const QUESTION_TYPES_MAP = {
  0: 'Input',
  1: 'Checkbox',
  2: 'Radio Button',
  3: 'Single Select',
  4: 'Multiple Select',
  5: 'Datepicker',
  6: 'Rated'
}

export const SALES_CHANNELS_MAP = {
  1: 'primary-lighten',
  2: 'warning-lighten',
  3: 'info-lighten',
  4: 'danger-lighten',
  5: 'success-lighten'
}

export const INTEREST_TYPES_MAP = {
  'App\\Models\\Category': t('constants.constants.interest_types_map.category'),
  'App\\Models\\Region': t('constants.constants.interest_types_map.region'),
  'App\\Models\\Retailer': t('constants.constants.interest_types_map.retailer'),
  'App\\Models\\Product': t('constants.constants.interest_types_map.product'),
  'App\\Models\\SalesChannel': t('constants.constants.interest_types_map.sales_channel'),
  'App\\Models\\Campaign': t('constants.constants.interest_types_map.campaign'),
  'App\\Models\\RomaniaApplicantType': t('constants.constants.interest_types_map.romania_applicant_type'),
  'App\\Models\\Rank': t('constants.constants.interest_types_map.rank')
}

export const INTEREST_STATUSES = {
  INACTIVE: 0,
  ACTIVE: 1
}

export const INTEREST_STATUSES_MAP = {
  0: t('shared.common.inactive'),
  1: t('shared.common.active')
}

export const QUESTION_REQUIREMENT_TYPES_MAP = {
  'App\\Models\\SubCategory': t('shared.common.sub_category'),
  'App\\Models\\Choice': t('constants.constants.question_requirement_types_map.choice')
}

export const RETAILER_USER_TYPE = {
  USER: 0,
  OWNER: 1
}

export const COUPON_DISCOUNT_TYPE = {
  AMOUNT: 0,
  RATE: 1
}

export const COUPON_DISCOUNT_TYPE_MAP = {
  0: t('constants.constants.coupon_discount_type_map.amount'),
  1: t('constants.constants.coupon_discount_type_map.rate')
}

export const COUPON_DISCOUNT_TYPE_DATA = [
  {
    id: 0,
    name: t('constants.constants.coupon_discount_type_map.amount')
  },
  { id: 1, name: t('constants.constants.coupon_discount_type_map.rate') }
]

export const COUPON_REQUIREABLE_TYPE_MAP = {
  'App\\Models\\Brand': t('constants.constants.coupon_requireable_type.brand'),
  'App\\Models\\Category': t('constants.constants.coupon_requireable_type.category'),
  'App\\Models\\City': t('constants.constants.coupon_requireable_type.city'),
  'App\\Models\\County': t('constants.constants.coupon_requireable_type.county'),
  'App\\Models\\Product': t('constants.constants.coupon_requireable_type.product'),
  'App\\Models\\Region': t('constants.constants.coupon_requireable_type.region'),
  'App\\Models\\Retailer': t('constants.constants.coupon_requireable_type.retailer'),
  'App\\Models\\SalesChannel': t('constants.constants.coupon_requireable_type.sales_channels'),
  'App\\Models\\SubCategory': t('shared.common.sub_category'),
  'App\\Enums\\Paymentethod': t('constants.constants.coupon_requireable_type.payment_method'),
  'App\\Enums\\PlatformType': t('constants.constants.coupon_requireable_type.platform_type')
}

export const COUPON_REQUIREABLE_TYPE_DATA = [
  {
    id: 'App\\Models\\Brand',
    name: t('constants.constants.coupon_requireable_type.brand'),
    searchable: true
  },
  {
    id: 'App\\Models\\Category',
    name: t('constants.constants.coupon_requireable_type.category'),
    searchable: false
  },
  {
    id: 'App\\Models\\City',
    name: t('constants.constants.coupon_requireable_type.city'),
    searchable: false
  },
  {
    id: 'App\\Models\\County',
    name: t('constants.constants.coupon_requireable_type.county'),
    searchable: true
  },
  {
    id: 'App\\Models\\Product',
    name: t('constants.constants.coupon_requireable_type.product'),
    searchable: true
  },
  {
    id: 'App\\Models\\Region',
    name: t('constants.constants.coupon_requireable_type.region'),
    searchable: false
  },
  {
    id: 'App\\Models\\Retailer',
    name: t('constants.constants.coupon_requireable_type.retailer'),
    searchable: true
  },
  {
    id: 'App\\Models\\SalesChannel',
    name: t('constants.constants.coupon_requireable_type.sales_channels'),
    searchable: false
  },
  {
    id: 'App\\Models\\SubCategory',
    name: t('shared.common.sub_category'),
    searchable: false
  },
  {
    id: 'App\\Enums\\PaymentMethod',
    name: t('constants.constants.coupon_requireable_type.payment_method'),
    searchable: false
  },
  {
    id: 'App\\Enums\\PlatformType',
    name: t('constants.constants.coupon_requireable_type.platform_type'),
    searchable: false
  }
]

export const ORDER_CANCELLATION_REASON = {
  PAYMENT_DATE: 0,
  PRODUCT: 1,
  CASH: 2,
  HIGH_PRICE: 3,
  INCOMPLETE_DELIVERY: 4,
  INCORRECT_DOCUMENT: 5,
  PAYMENT_METHOD: 6,
  INCOMPLETE_WORKFLOWS: 7,
  AUTO_CANCEL: 8,
  ANOMALY_DETECTION: 9
}

export const ORDER_CANCELLATION_REASON_DATA = [
  { id: 0, name: t('constants.constants.order_cancellation_reason.due_date_change') },
  { id: 1, name: t('constants.constants.order_cancellation_reason.product_change') },
  { id: 2, name: t('constants.constants.order_cancellation_reason.cash_payment_request') },
  { id: 3, name: t('constants.constants.order_cancellation_reason.high_price') },
  { id: 4, name: t('constants.constants.order_cancellation_reason.incompleted_delivery') },
  { id: 5, name: t('constants.constants.order_cancellation_reason.incorrect_document') },
  { id: 6, name: t('constants.constants.order_cancellation_reason.payment_method') },
  { id: 7, name: t('constants.constants.order_cancellation_reason.incomplete_workflows') },
  { id: 9, name: t('constants.constants.order_cancellation_reason.anomaly_detection') }
]

export const ORDER_CANCELLATION_REASON_DATA_FOR_RETAILER = [
  { id: 0, name: t('constants.constants.order_cancellation_reason.due_date_change') },
  { id: 1, name: t('constants.constants.order_cancellation_reason.product_change') },
  { id: 2, name: t('constants.constants.order_cancellation_reason.cash_payment_request') },
  { id: 3, name: t('constants.constants.order_cancellation_reason.high_price') },
  { id: 4, name: t('constants.constants.order_cancellation_reason.incompleted_delivery') },
  { id: 5, name: t('constants.constants.order_cancellation_reason.incorrect_document') },
  { id: 6, name: t('constants.constants.order_cancellation_reason.payment_method') }
]

export const ORDER_CANCELLATION_REASON_DATA_FOR_RO = [
  { id: 0, name: t('constants.constants.order_cancellation_reason.due_date_change') },
  { id: 1, name: t('constants.constants.order_cancellation_reason.product_change') },
  { id: 3, name: t('constants.constants.order_cancellation_reason.high_price') },
  { id: 4, name: t('constants.constants.order_cancellation_reason.incompleted_delivery') },
  { id: 5, name: t('constants.constants.order_cancellation_reason.incorrect_document') },
  { id: 6, name: t('constants.constants.order_cancellation_reason.payment_method') }
]

export const ORDER_CANCELLATION_REASON_DATA_FOR_CAR_SALES = [
  { id: 10, name: t('constants.constants.order_cancellation_reason.customer_withdrawal') },
  { id: 11, name: t('constants.constants.order_cancellation_reason.identity_income_verification_issue') },
  { id: 12, name: t('constants.constants.order_cancellation_reason.missing_documents') },
  { id: 13, name: t('constants.constants.order_cancellation_reason.vehicle_legal_obstacle') },
  { id: 14, name: t('constants.constants.order_cancellation_reason.casco_insurance_unavailable') },
  { id: 15, name: t('constants.constants.order_cancellation_reason.inspection_issue') },
  { id: 9, name: t('constants.constants.order_cancellation_reason.anomaly_detection') },
  { id: 0, name: t('constants.constants.order_cancellation_reason.due_date_change') },
  { id: 16, name: t('constants.constants.order_cancellation_reason.dealer_initiated_cancellation') },
  { id: 17, name: t('constants.constants.order_cancellation_reason.delivery_terms_dispute') }
]
export const ORDER_CANCELLATION_REASON_MAP = {
  0: t('constants.constants.order_cancellation_reason.due_date_change'),
  1: t('constants.constants.order_cancellation_reason.product_change'),
  2: t('constants.constants.order_cancellation_reason.cash_payment_request'),
  3: t('constants.constants.order_cancellation_reason.high_price'),
  4: t('constants.constants.order_cancellation_reason.incompleted_delivery'),
  5: t('constants.constants.order_cancellation_reason.incorrect_document'),
  6: t('constants.constants.order_cancellation_reason.payment_method'),
  7: t('constants.constants.order_cancellation_reason.incomplete_workflows'),
  8: t('constants.constants.order_cancellation_reason.auto_cancel'),
  9: t('constants.constants.order_cancellation_reason.anomaly_detection'),
  10: t('constants.constants.order_cancellation_reason.customer_withdrawal'),
  11: t('constants.constants.order_cancellation_reason.identity_income_verification_issue'),
  12: t('constants.constants.order_cancellation_reason.missing_documents'),
  13: t('constants.constants.order_cancellation_reason.vehicle_legal_obstacle'),
  14: t('constants.constants.order_cancellation_reason.casco_insurance_unavailable'),
  15: t('constants.constants.order_cancellation_reason.inspection_issue'),
  16: t('constants.constants.order_cancellation_reason.dealer_initiated_cancellation'),
  17: t('constants.constants.order_cancellation_reason.delivery_terms_dispute')
}

export const NOTIFICATION_TYPES = {
  BAR: 0,
  MODAL: 1,
  TOAST: 2,
  REFRESH: 3
}

export const SYSTEM_NOTIFICATION_TYPES_MAP = {
  0: 'Bar',
  1: 'Modal',
  3: 'Refresh Modal'
}

export const NOTIFICATION_SEVERITY_TYPES_MAP = {
  0: t('constants.constants.notification_severity_types.info'),
  1: t('constants.constants.notification_severity_types.warning'),
  2: t('constants.constants.notification_severity_types.error'),
  3: t('constants.constants.notification_severity_types.notice')
}

export const NOTIFICATION_SEVERITY_TYPE_CLASSES = {
  0: 'info',
  1: 'warning',
  2: 'danger',
  3: 'success'
}

export const NOTIFICATION_SEVERITY_TYPE_ICONS = {
  0: 'mdi mdi-information-outline text-info',
  1: 'mdi mdi-alert-outline text-warning',
  2: 'mdi mdi-cancel text-danger',
  3: 'mdi mdi-party-popper text-success'
}

export const NOTIFICATION_SEVERITY_TYPES = {
  INFO: 0,
  WARNING: 1,
  DANGER: 2,
  SUCCESS: 3
}

export const WORKFLOW_STATUSES_MAP = {
  false: t('shared.common.inactive'),
  true: t('shared.common.active')
}

export const WORKFLOW_IS_REQUIRED_FOR_PAYMENT_MAP = {
  false: t('shared.common.no'),
  true: t('shared.common.yes')
}

export const WORKFLOW_IS_REQUIRED_FOR_INVOICE_MAP = {
  false: t('shared.common.no'),
  true: t('shared.common.yes')
}

export const GOAL_STATUSES = {
  INACTIVE: false,
  ACTIVE: true
}

export const GOAL_STATUSES_FOR_GOALS_PAGE = {
  INACTIVE: 'false',
  ACTIVE: 'true'
}

export const GOAL_STATUSES_MAP = {
  false: t('shared.common.inactive'),
  true: t('shared.common.active')
}

export const QUESTION_HIDE_FOR_ORDER_DETAIL_STATUSES_MAP = {
  false: t('shared.common.no'),
  true: t('shared.common.yes')
}

export const GOAL_TYPES = {
  ORDER_AMOUNT: 0,
  ORDER_COUNT: 1
}

export const GOAL_TYPES_MAP = {
  0: t('constants.constants.goal_types.order_amount'),
  1: t('constants.constants.goal_types.order_count')
}

export const PURCHASE_PERIOD_TYPES = {
  'App\\Models\\SubCategory': t('shared.common.sub_category'),
  'App\\Models\\Region': t('shared.common.region'),
  'App\\Models\\City': t('shared.common.city'),
  'App\\Models\\Crop': t('shared.common.crop'),
  'App\\Models\\SalesChannel': t('shared.common.sales_channel')
}

export const ANOMALY_STATUSES = {
  NONE: 0,
  LOW: 1,
  MEDIUM: 2,
  HIGH: 3
}

export const MOBILE_STATUSES = {
  false: t('shared.common.disabled'),
  true: t('shared.common.enabled')
}

export const PRODUCT_STATUSES = {
  false: t('shared.common.inactive'),
  true: t('shared.common.active')
}

export const TWO_FACTOR_STATUSES = {
  NOT_SPECIFIED: 0,
  OTP: 1,
  SMS: 2
}

export const TWO_FACTOR_STATUSES_MAP = {
  0: t('constants.constants.two_factor_statuses.not_specified'),
  1: 'OTP',
  2: 'SMS'
}

export const DELIVERY_CONFIRMATION_WORKFLOW_JOB_ID = 6
export const GUARANTOR_CONFIRMATION_WORKFLOW_JOB_ID = 25

export const PHONE_SURVEY_TYPES_MAP = {
  0: t('constants.constants.phone_survey_types.7_days_before_reminder'),
  1: t('constants.constants.phone_survey_types.1_day_before_reminder'),
  2: t('constants.constants.phone_survey_types.delivery_reminder'),
  3: t('constants.constants.phone_survey_types.guarantor_confirmation'),
  6: t('constants.constants.phone_survey_types.customer_delivery_reminder')
}

export const FARMER_SATISFACTION_SURVEY_TARGET_TYPE_MAP = {
  ORDER_WITH_PROMISSORY_NOTE_PAYMENT_COMPLETED: 14,
  ORDER_WITH_BANK_TRANSFER_PAYMENT_COMPLETED: 15,
  MOBILE_APPLICATION_ORDER_COMPLETED: 16,
  RETAILER_APPLICATION_ORDER_COMPLETED: 17
}

export const APPLICATION_MANUAL_CHECK_MAP = {
  true: t('constants.constants.application_manual_check.ad_check'),
  false: t('constants.constants.application_manual_check.not_necessary')
}

export const ORDER_EXPENSE_TYPE = {
  PROMISSORY_NOTE_COLLECTION_FEE: 1
}

export const MULTIPLE_RETAILER_DOCUMENTS = [17]

export const BADGE_MAP = {
  0: 'secondary-lighten',
  1: 'info-lighten',
  2: 'warning-lighten',
  3: 'success-lighten',
  4: 'danger-lighten'
}

export const ORDER_WORKFLOW_JOBS = {
  DOCUMENTS_SIGNED: 1,
  PROMISSORY_NOTE_STORE: 2,
  DOCUMENTS_WITH_WET_SIGNATURE_RECEIVED: 3,
  LETTER_SENT: 4,
  PRODUCTS_PURCHASED: 5,
  DELIVERY: 6,
  LEGAL_PROCEEDING_BEGAN: 7,
  RETAILER_DELIVERY: 8,
  DEBT_EXPENSED: 9,
  RETAILER_INVOICE: 10,
  RETAILER_COMMISSION_INVOICE: 11,
  RETAILER_COLLECTION: 12,
  CONFIRM_PROMISSORY_NOTE_DOCUMENT: 13,
  FARMER_IDENTITY_CARD_DOCUMENT: 14,
  CONFIRM_FIBA_CREDIT_ISSUED: 19,
  CONFIRM_INCOME_DELIVERY: 20,
  CONFIRM_CANCELLED_PROMISSORY_NOTE_SHIPPED: 23,
  FARMER_PAID_PROMISSORY_NOTES_SHIPPING: 24,
  PROMISSORY_NOTE_DESTRUCTION: 28,
  CONFIRM_PROMISSORY_NOTE_COME_BACK: 29,
  CONFIRM_IS_PROTESTED: 30,
  CONFIRM_ANIMAL_PASSPORT: 26,
  CONFIRM_INCOME_PROTECTED_SALE_CONTRACT: 27,
  CONFIRM_DIGITAL_PROMISSORY_NOTE_DOCUMENT: 35,
  CONFIRM_CREDIT_BUREAU_DEBT_REPORTING: 36,
  CONFIRM_CREDIT_AGREEMENT_DOCUMENT: 37,
  CONFIRM_REPAYMENT_SCHEDULE_DOCUMENT: 38,
  CONFIRM_ANNEX_2_DOCUMENT: 39,
  CONFIRM_SERIAL_NUMBER_ENTERED: 40,
  CONFIRM_DEBT_DEFAULTED: 41,
  CONFIRM_DEBT_DEFAULT_WARNING_SENT: 42,
  CONFIRM_INSTALLMENT_SALES_CONTRACT: 43,
  CONFIRM_CUSTOMER_DELIVERY: 44,
  CONFIRM_SIGNED_SALES_CONTRACT: 45,
  CONFIRM_DIGITAL_SIGNED_SALES_CONTRACT: 46,
  CONFIRM_SEQUENTIAL_PROMISSORY_NOTE: 47,
  CONFIRM_DIGITAL_SEQUENTIAL_PROMISSORY_NOTE: 48,
  CONFIRM_VEHICLE_INSPECTION_REPORT: 49,
  CONFIRM_DOWN_PAYMENT_COLLECTION: 50,
  CONFIRM_CASCO_INSURANCE_POLICY: 51,
  CONFIRM_VEHICLE_REGISTRATION_TRANSFER: 52,
  CONFIRM_KEY_HANDOVER: 53,
  CONFIRM_DIGITAL_DOCUMENTS_SIGNED: 54
}

export const VAT_RATES = {
  tr: [0, 1, 10, 20],
  ro: [0, 9, 19]
}

export const PHONE_NUMBER_TO_SEND_DOCUMENTS = {
  tr: '0536 596 54 35',
  ro: '0734 928 158'
}

export const UPLOAD_DOCUMENT_TYPE = {
  SIGNED: 1,
  CANCELED: 2,
  SHIPPED: 3,
  MARKED_AS_SHIPPED: 4,
  CONTROL: 5,
  FARMER_IDENTITY_CARD: 6,
  SIGNED_INCOME_PROTECTED_SALE_CONTRACT: 7,
  SIGNED_INSTALLMENT_SALES_CONTRACT: 8,
  SIGNED_CAR_SALES_CONTRACT: 9
}
export const UPLOAD_DOCUMENT_TYPE_MAP = {
  1: t('views.admin.documents.upload_document_type_signed'),
  2: t('views.admin.documents.upload_document_type_canceled'),
  3: t('views.admin.documents.upload_document_type_shipped'),
  4: t('views.admin.documents.upload_document_type_marked_as_shipped'),
  5: t('views.admin.documents.upload_document_type_control'),
  6: t('views.admin.documents.upload_document_type_farmer_identity_card'),
  7: t('views.admin.documents.upload_document_type_income_protected_sales_contract'),
  8: t('views.admin.documents.upload_document_type_signed_installment_sales_contract'),
  9: t('views.admin.documents.upload_document_type_signed_car_sales_contract')
}
export const REQUIRED_DOCUMENT_STATUSES = {
  WAITING: 1,
  SUCCESS: 2,
  ERROR: 3,
  INVALID: 4
}
export const PROMISSORY_ATTENTION_TEXT = [
  'Çiftçi ismi tam ve doğru yazılmış olmalı. Kontrol ediniz',
  'İki imza atılmış olmalı. Kontrol ediniz',
  'Mavi kalemle yazılmış olmalı. Kontrol ediniz',
  'Silik yazı veya imza olmamalı. Kontrol ediniz',
  'Ürünleri teslim aldım cümlesi çiftçi tarafından yazılmış olmalı. Kontrol ediniz',
  'Kimlikteki imza ile senet üzerinde imza tutarlı ve benzer olmalı ',
  'Eğer okuma yazması olmayan bir çiftçi ise yalnızca izin verilen bayilerde kefil ile senet doldurulmalı'
]

export const PRODUCT_LISTING_TYPE = {
  PRODUCTS_HAVE_STOCK_INPUT: 0,
  PRODUCTS_FOR_SHORT_SALE: 1
}

export const PRODUCT_LISTING_TYPE_MAP = {
  0: t('views.retailer.applications.forwardSale.product_card.sell_from_stock'),
  1: t('views.retailer.applications.forwardSale.product_card.get_it_with_tarfin_pro')
}

export const PHONE_NUMBER_TO_SEND_DOCUMENTS_FOR_FV = '0 (536) 596 54 35'

export const RETAILER_STOCK_INPUT_INVOICE_COMPANY_TYPES = {
  SUPPLIER: 1,
  SHIPPING: 2
}

export const RETAILER_STOCK_INPUT_INVOICE_COMPANY_TYPES_MAP = {
  1: t('constants.constants.retailer_stock_input_invoice_company_types.supplier'),
  2: t('constants.constants.retailer_stock_input_invoice_company_types.shipping')
}

export const RETAILER_STOCK_INPUT_INVOICE_COMPANY_TYPES_OPTIONS_DATA = [
  {
    id: 1,
    name: t('constants.constants.retailer_stock_input_invoice_company_types.supplier')
  },
  {
    id: 2,
    name: t('constants.constants.retailer_stock_input_invoice_company_types.shipping')
  }
]

export const RETAILER_STOCK_INPUT_INVOICE_COMPANY_TYPES_DATA = [
  {
    id: '1_1',
    text: t('views.admin.retailer_stock_inputs.invoice.data.has_supplier')
  },
  {
    id: '2_1',
    text: t('views.admin.retailer_stock_inputs.invoice.data.has_shipping')
  },
  {
    id: '1_0',
    text: t('views.admin.retailer_stock_inputs.invoice.data.has_no_supplier')
  },
  {
    id: '2_0',
    text: t('views.admin.retailer_stock_inputs.invoice.data.has_no_shipping')
  }
]

export const CATEGORY_TYPE = {
  FERTILIZER: 1,
  FEED_ADDITIVE: 8
}

export const DECISION_TYPES_SUCCESS = [
  'RecommendedLimitWithScoreByMLSpecification',
  'RecommendedLimitWithoutScoreByMlSpecification',
  'AdditionalAvailableLimitByMLSpecification',
  'RecommendedLimitByADSpecification',
  'RetailerApprovedWithInitiativeSpecification',
  'ScoreApproveSpecification'
]

export const DECISION_TYPES_WARNING = ['HighAmountRequestedSpecification', 'ScoreRejectSpecificationWithLimit']

export const FARMER_PAYMENT_DATE_RANGE = {
  MIN_DAY: 30,
  MAX_DAY: 360
}

export const FARMER_PAYMENT_DATE_RANGE_RO = {
  MIN_DAY: 60,
  MAX_DAY: 360
}

export const FARMER_PAYMENT_DATE_CHANGE_RANGE = {
  MIN_DAY: -120,
  MAX_DAY: 120
}

export const RETAILER_TYPE_BY_SALES_CHANNELS_AND_HISTORY_DATA = [
  {
    value: 0,
    text: t('views.admin.retailers.all_retailers')
  },
  {
    value: 1,
    text: t('views.admin.retailers.new_retailers')
  },
  {
    value: 2,
    text: t('views.admin.retailers.closed_retailers')
  }
]
export const ROMANIA_SALES_CHANNEL_CONVERTATION_OPTIONS_DATA = [
  {
    id: 10,
    text: 'SRL->IFN'
  },
  {
    id: 99,
    text: 'IFN->IFN'
  }
]

export const TARFIN_COMPANY_TYPE_FOR_RO = {
  SRL: t('constants.constants.tarfin_company_type_for_ro.srl'),
  IFN: t('constants.constants.tarfin_company_type_for_ro.ifn')
}

export const ORDER_NETTING_PREVIEW = {
  PARTIALLY_NETTING: 0,
  FULLY_NETTING: 1
}

export const CATEGORIES = {
  AGRICULTURAL_PESTICIDES: 6
}

export const GTS_STATUS = {
  PENDING: 1,
  PARTIAL: 2,
  COMPLETED: 3
}

export const PAYMENT_PROVIDER_PAYMENT_STATUS = {
  PENDING: 0,
  SUCCESS: 1,
  FAILED: 2
}

export const GM_ROLE_NAME = 'GM'

export const PRE_APPROVED_LIMIT_EXPIRATION_WARNING_DAYS = 3

export const DOCUMENT_UPLOAD_GUIDE_URL =
    'https://tarfinprod-public.s3.eu-central-1.amazonaws.com/pdf/Tarfin+Flex+-+Bas%CC%A7vuru+Evraklar%C4%B1n%C4%B1n+Sisteme+Yu%CC%88klenmesi.pdf'
